import React from "react";
import {withRouter} from "react-router";
import {Card, CardContent} from "@material-ui/core";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import APPCONFIG from "../../constants/Config";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import {confirmAlert} from "react-confirm-alert";

export default class AltrupaySpinProcessor extends Framework.Components.Object {

	constructor(props) {
		/**
		 * @typedef {Terminals_Altrupay_Object} this.state
		 */
		super(props, Types.Terminals_Altrupay._name);
	}


	handleSubmit = async () => {
		if (this.props.terminal_amount > 0) {
			confirmAlert({
				title: 'Confirm Terminal Addition',
				message: 'Each additional terminal costs $50, click Yes to confirm payment.',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							await super.handleSubmit();
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		} else {
			await super.handleSubmit();
		}

	}

	afterSubmit = async () => {
		const isTacticalPay = window.isTacticalPay;
		const settingTab = isTacticalPay ? '/settings#tacticalpay' : '/settings#altrupay';

		if (this.props.terminal_amount > 0) {
			let aModel = new API.BuildClass(Types.Terminals._name, 'POST_TERMINAL_STRIPE_ALTRUPAY');
			await aModel.submit(this, 'POST_TERMINAL_STRIPE_ALTRUPAY', true);
		}

		//reload the tab
		this.props.history.push('/');
		this.props.history.push(settingTab);
	}

	form = () => {
		/** @type {Terminals_Altrupay_Properties} */
		let {properties} = this.model;
		/** @type {Terminals_Altrupay_Object} */
		let object = this.state;
		return (
			<Card>
				<CardContent>
					<div className={'row'}>
						<div className={'col-4'}>
							<div className={'form-group'}>
								<Framework.Elements.TextField
									label={"TPN Code"}
									property={properties.tpn}
									value={object.tpn}
									error={object.tpn_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className={'form-group'}>
								<Framework.Elements.TextField
									label={"Auth Key"}
									property={properties.authkey}
									value={object.authkey}
									error={object.authkey_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={'col-12'}>
							<div className={'form-group'}>
								<Framework.Elements.TextField
									label={"Ecom Token (pay-by-link / FTD)"}
									property={properties.ecom_token}
									value={object.ecom_token}
									error={object.ecom_token_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
								<small className="text-muted">
									From iPOSpays Merchant Settings → Merchant Keys → Ecom Token for this TPN. Not the same as Auth Key.
								</small>
							</div>
						</div>
						<div className={'col-4'}>
							<div className={'form-group'}>
								<Framework.Elements.TextField
									label={"Terminal Nickname"}
									property={properties.nickname}
									value={object.nickname}
									error={object.nickname_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</CardContent>
			</Card>
		)
	}
}
